import React from 'react';
import { C } from './constants';
type BtnVariant = 'crimson' | 'email' | 'wa' | 'tg' | 'outline';
export function Btn({
  onClick,
  children,
  variant = 'crimson',
  disabled = false,
  type = 'button'
}: {
  onClick?: () => void;
  children: ReactNode;
  variant?: BtnVariant;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}) {
  const variants: Record<BtnVariant, React.CSSProperties> = {
    crimson: {
      background: `linear-gradient(135deg,${C.crimson},#6B0F0F)`,
      color: '#FFF8EC',
      border: `2px solid ${C.crimson}`
    },
    email: {
      background: `linear-gradient(135deg,#1a3a6b,#1d4ed8)`,
      color: '#fff',
      border: '2px solid #1a3a6b'
    },
    wa: {
      background: `linear-gradient(135deg,${C.waGreen},#1da851)`,
      color: '#fff',
      border: `2px solid ${C.waDark}`
    },
    tg: {
      background: `linear-gradient(135deg,${C.tgBlue},${C.tgDark})`,
      color: '#fff',
      border: `2px solid ${C.tgDark}`
    },
    outline: {
      background: '#fff',
      color: C.crimsonMid,
      border: `2px solid ${C.crimsonMid}`
    }
  };
  const s = variants[variant] || variants.crimson;
  return <button type={type} onClick={onClick} disabled={disabled} style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 22px',
    borderRadius: 10,
    fontSize: 13,
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: 'inherit',
    letterSpacing: '0.3px',
    opacity: disabled ? 0.5 : 1,
    ...s
  }} data-id="element-345">
      {children}
    </button>;
}